'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactTransitionGroup = require('react-transition-group');

var _options = require('../dropdown/options');

var _options2 = _interopRequireDefault(_options);

var _es6PromiseDebounce = require('es6-promise-debounce');

var _es6PromiseDebounce2 = _interopRequireDefault(_es6PromiseDebounce);

var _input = require('../input');

var _input2 = _interopRequireDefault(_input);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _loader = require('../loader');

var _loader2 = _interopRequireDefault(_loader);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_style2.default);

var InputSearch = function (_PureComponent) {
  _inherits(InputSearch, _PureComponent);

  function InputSearch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputSearch.__proto__ || Object.getPrototypeOf(InputSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fetchingCount: 0,
      focused: false,
      result: []
    }, _this.onFocus = function () {
      return _this.setState({ focused: true });
    }, _this.onBlur = function () {
      return setTimeout(function () {
        return _this.setState({ focused: false });
      }, 100);
    }, _this.incrementFetching = function () {
      return _this.setState({ fetchingCount: _this.state.fetchingCount + 1 });
    }, _this.decrementFetching = function () {
      return _this.setState({ fetchingCount: _this.state.fetchingCount - 1 });
    }, _this.handleRequest = (0, _es6PromiseDebounce2.default)(function (value) {
      _this.incrementFetching();
      _this.props.request(value).then(function (response) {
        _this.decrementFetching();
        return _this.setState({ result: response.data.map(_this.props.mapResult) });
      }).catch(function (error) {
        _this.decrementFetching();
        return Promise.reject({ _error: error });
      });
    }, _this.props.delay), _this.handleChange = function (value) {
      if (value) {
        _this.handleRequest(value);
      }

      return _this.props.input.onChange(value);
    }, _this.handleClear = function () {
      _this.setState({
        fetchingCount: 0,
        focused: false,
        result: []
      });

      return _this.props.input.onChange(null);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputSearch, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var allowedProps = _extends({}, this.props);

      delete allowedProps.request;
      delete allowedProps.mapResult;
      delete allowedProps.delay;

      return _react2.default.createElement(
        'div',
        { className: cx('xsui-input__mod-search') },
        _react2.default.createElement(_input2.default, _extends({}, allowedProps, {
          input: _extends({}, allowedProps.input, {
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onChange: function onChange(e) {
              return _this2.handleChange(e.target.value);
            }
          }),
          autoComplete: 'off',
          offset: !!this.state.fetchingCount || allowedProps.input.value ? 'both' : 'left',
          icon: 'search',
          extra: _react2.default.createElement(
            _react.Fragment,
            null,
            this.state.fetchingCount ? _react2.default.createElement(_loader2.default, { size: 'sm' }) : allowedProps.input.value && _react2.default.createElement(_icon2.default, { name: 'circle-remove-mini', hoverable: true, onClick: this.handleClear })
          )
        })),
        _react2.default.createElement(
          _reactTransitionGroup.TransitionGroup,
          null,
          this.state.focused && allowedProps.input.value && !!this.state.result.length && _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            { classNames: 'slide-transition', timeout: 200 },
            _react2.default.createElement(_options2.default, {
              appearance: 'tertiary',
              size: 'sm',
              items: this.state.result,
              value: allowedProps.input.value,
              onChange: function onChange(value) {
                return allowedProps.input.onChange(value);
              }
            })
          )
        )
      );
    }
  }]);

  return InputSearch;
}(_react.PureComponent);

InputSearch.propTypes = Object.assign({}, _input.bpfrpt_proptype_Props === _propTypes2.default.any ? {} : _input.bpfrpt_proptype_Props, {
  request: _propTypes2.default.func.isRequired,
  mapResult: _propTypes2.default.func,
  delay: _propTypes2.default.number
});
InputSearch.defaultProps = {
  mapResult: function mapResult(a) {
    return a;
  },
  delay: 250
};
exports.default = InputSearch;